// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v2/create_phone_number.proto

/* oxlint-disable */
import { ApiUser } from "./user";

/** Wrapper matching the { "user": { "phone_number": "..." } } request body shape. */
export interface ApiCreatePhoneNumberUser {
  /** The new phone number in E.164 international format without spaces. */
  readonly phoneNumber: string;
}

/** Request message for CreatePhoneNumber (POST /v2/users/me/phone_number). */
export interface ApiCreatePhoneNumberRequest {
  /** Phone number wrapped in user object as required by the API. */
  readonly user: ApiCreatePhoneNumberUser | null;
}

/** Response message for CreatePhoneNumber. */
export interface ApiCreatePhoneNumberResponse {
  /** The updated user data. */
  readonly user: ApiUser | null;
}

export const ApiCreatePhoneNumberUser: MessageFns<ApiCreatePhoneNumberUser> = {
  fromJSON(object: any): ApiCreatePhoneNumberUser {
    return { phoneNumber: isSet(object.phone_number) ? globalThis.String(object.phone_number) : "" };
  },

  toJSON(message: ApiCreatePhoneNumberUser): unknown {
    const obj: any = {};
    if (message.phoneNumber !== undefined && message.phoneNumber !== null) {
      obj.phone_number = message.phoneNumber;
    }
    return obj;
  },
};

export const ApiCreatePhoneNumberRequest: MessageFns<ApiCreatePhoneNumberRequest> = {
  fromJSON(object: any): ApiCreatePhoneNumberRequest {
    return { user: isSet(object.user) ? ApiCreatePhoneNumberUser.fromJSON(object.user) : null };
  },

  toJSON(message: ApiCreatePhoneNumberRequest): unknown {
    const obj: any = {};
    if (message.user !== undefined && message.user !== null) {
      obj.user = ApiCreatePhoneNumberUser.toJSON(message.user);
    }
    return obj;
  },
};

export const ApiCreatePhoneNumberResponse: MessageFns<ApiCreatePhoneNumberResponse> = {
  fromJSON(object: any): ApiCreatePhoneNumberResponse {
    return { user: isSet(object.user) ? ApiUser.fromJSON(object.user) : null };
  },

  toJSON(message: ApiCreatePhoneNumberResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined && message.user !== null) {
      obj.user = ApiUser.toJSON(message.user);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
